JACADI.dataLayerUser = {

    infos: JSON.parse(localStorage.getItem('dataLayers')),

    loadUser: function () {
        const infos = JACADI.dataLayerUser.infos;
        if (infos !== null && Date.now() - infos.lastCacheDate <= 30 * 60 * 1000) {
            JACADI.dataLayerUser.pushDataLayer(infos);
        } else {
            JACADI.session.init().done(function () {
                $.ajax({
                    url: JACADI.AJAX.datalayerUserInfos,
                    cache: false,
                    async: false,
                    type: 'GET',
                    dataType: 'json',
                    success: function (jsonData) {

                        JACADI.dataLayerUser.storeDataLayer(jsonData);
                        JACADI.dataLayerUser.pushDataLayer(JACADI.dataLayerUser.infos);

                    }
                });
            });
        }
    },

    storeDataLayer: function (jsonData) {
        // Check local storage support
        if (window.localStorage !== null) {
            JACADI.dataLayerUser.infos = {
                'user_email': jsonData.email,
                'user_logged_email': jsonData.loggedEmail,
                'isUserLogged': Boolean(jsonData.loggedin),
                'user_optinMail': jsonData.optinMail,
                'user_optinSms': jsonData.optinSms,
                'user_optinPartnerMail': jsonData.optinPartnerMail,
                'user_lastLogin': jsonData.lastLogin,
                'user_fidscore': jsonData.fidScore,
                'user_lastorder_Date': jsonData.lastOrderDate,
                'newCustomer': '',
                'user_birthlistDate': jsonData.birthlistCreationDate,
                'user_fidcheques': jsonData.loyaltyChecksExpiryDates,
                'user_fid_exp_Date': jsonData.loyaltyCardExpiryDate,
                'user_ChildrenBirthDates': jsonData.childrenBirthDates,
                'basket_totalItems': jsonData.nbOfCartItems,
                'basket_totalPrice': jsonData.basketTotalPrice,
                'basket_giftwrap': Boolean(jsonData.basketGiftWrap),
                'userId': jsonData.jacadiMdmUrId ? jsonData.jacadiMdmUrId : jsonData.jacadiClientId,
                'clientTypeCrm': jsonData.customerType,
                'lastCacheDate': Date.now()
            };

            if (JACADI.dataLayerUser.infos.isUserLogged === true) {
                if (jsonData.totalOrders < 1 || (jsonData.totalOrders == 1 && window.location.pathname.includes('checkout/orderConfirmation'))) {
                    JACADI.dataLayerUser.infos['newCustomer'] = true;
                } else {
                    JACADI.dataLayerUser.infos['newCustomer'] = false;
                }
            }

            // Save array
            localStorage.setItem('dataLayers', JSON
                .stringify(JACADI.dataLayerUser.infos));
        }
    },

    pushDataLayer: function (dataLayers) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayers);
    },
}